import { Document, StyleSheet, View } from '@react-pdf/renderer';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { formateWithMoment } from '../../../../../utilz/dates';
import {
  PDFCheckBox,
  PDFPage,
  PDFRow,
  PDFTable,
  PDFTableCell,
  PDFTableRow,
  PDFText,
} from '../../components/CommonPdfComponents';

const OverChargeClaimDetailsPrint = ({ claimDetails, namespace }) => {
  const claimItems = useMemo(() => (claimDetails?.claimItem ? claimDetails?.claimItem : []), [claimDetails?.claimItem]);

  const { t } = useTranslation([namespace, 'translation']);

  return (
    <Document onContextMenu={(e) => e.preventDefault()}>
      <PDFPage>
        <View style={{ paddingHorizontal: 5 }}>
          <PDFRow style={{ ...styles.headerRow, marginBottom: 5 }} justify="center" direction="column">
            <PDFText style={styles.title}>{t('translation:claims.presentation')}</PDFText>
          </PDFRow>
          <PDFRow style={styles.headerRow} direction="row" justify="space-between">
            <View style={{ width: '48%' }}>
              <View style={{ marginBottom: 5 }}>
                <View style={{ marginBottom: 5 }}>
                  <PDFText style={styles.title2}>{`${t('translation:claims.claimant')} :`}</PDFText>
                </View>
                <View>
                  <PDFText style={styles.text}>{claimDetails?.customerName}</PDFText>
                  <PDFText style={styles.text}>{claimDetails?.customerDetailName}</PDFText>
                  <PDFText style={styles.text}>{String(claimDetails?.customerDetailAddress).replace('\r', '')}</PDFText>
                  <PDFText style={styles.text}>
                    {String(claimDetails?.customerDetailCityStateZip).replace('\r', '')}
                  </PDFText>
                  <PDFText
                    style={{
                      ...styles.title,
                      fontSize: 9,
                      lineHeight: 1.1,
                      marginTop: 2,
                    }}
                  >
                    {t('translation:claims.forwardCorrespondence')} {claimDetails?.ocCheckPayableTo}
                  </PDFText>
                </View>
              </View>
            </View>
            <View style={{ width: '48%', height: '100%' }}>
              <PDFRow direction="column" justify="space-between" style={{ flex: 1 }}>
                <View>
                  <PDFText style={styles.title2}>{claimDetails?.customerName}</PDFText>
                  <PDFText style={styles.title2}>{`${t('translation:claims.ourClaimNumber')}:`}</PDFText>
                  <PDFText style={styles.title2}>{claimDetails?.customerClaimNo}</PDFText>
                </View>
                <View>
                  <PDFText
                    style={{
                      ...styles.title,
                      fontSize: 9,
                      lineHeight: 1.1,
                      marginTop: 2,
                    }}
                  >
                    {t('translation:claims.refer')}
                  </PDFText>
                </View>
              </PDFRow>
            </View>
          </PDFRow>
          <PDFRow style={{ ...styles.headerRow, marginTop: 3 }} direction="row" justify="space-between">
            <View style={{ width: '48%' }}>
              <View style={{ marginBottom: 5 }}>
                <View style={{ marginBottom: 5 }}>
                  <PDFText style={styles.title2}>Mail To :</PDFText>
                </View>
                <View>
                  <PDFText style={styles.text}>{claimDetails?.carrierName}</PDFText>
                  <PDFText style={styles.text}>{String(claimDetails?.carrierAddr1).replace('\r', '')}</PDFText>
                  {/* biome-ignore lint/suspicious/noDoubleEquals: <explanation> */}
                  {claimDetails?.carrierAddr2 != null && claimDetails?.carrierAddr2 != '' ? (
                    <PDFText style={{ ...styles.text, fontWeight: '600' }}>{claimDetails?.carrierAddr2}</PDFText>
                  ) : (
                    <></>
                  )}
                  <PDFText style={styles.text}>{claimDetails?.carrierCSZ}</PDFText>
                </View>
              </View>
            </View>
            <View style={{ width: '48%', height: '100%' }}>
              <View style={{ marginTop: 15 }}>
                <PDFText style={styles.title2}> {`${t('translation:claims.yourClaimNumber')} : `}</PDFText>
                <PDFText style={styles.title2}>{claimDetails?.carrierClaimNo}</PDFText>
              </View>
            </View>
          </PDFRow>
          <View style={{ marginTop: 5 }}>
            <PDFText style={{ ...styles.title2, marginBottom: 4 }}>
              {`${t('translation:claims.attachedDocumentation')} : `}
            </PDFText>
            <PDFRow>
              <View>
                <PDFCheckBox
                  fontWeight="600"
                  label={t('translation:claims.freightBill')}
                  isReverse
                  value={claimDetails?.fbAttach === 'Y'}
                  colon={false}
                />
              </View>
              <View style={{ marginLeft: 10 }}>
                <PDFCheckBox
                  fontWeight="600"
                  label={t('translation:default.fields.invoiceNumber')}
                  isReverse
                  value={claimDetails?.invAttach === 'Y'}
                  colon={false}
                />
              </View>
            </PDFRow>
            <PDFRow style={{ marginTop: 2 }}>
              <View>
                <PDFCheckBox
                  fontWeight="600"
                  label={t('translation:claims.houseBillOfLadingNumber')}
                  isReverse
                  value={claimDetails?.bolAttach === 'Y'}
                  colon={false}
                />
              </View>
              <View style={{ marginLeft: 10 }}>
                <PDFCheckBox
                  fontWeight="600"
                  label={t('translation:claims.others')}
                  isReverse
                  value={claimDetails?.otherAttach === 'Y'}
                  colon={false}
                />
              </View>
            </PDFRow>
          </View>
          <View style={styles.darkBorder} />
          <PDFRow style={{ ...styles.headerRow, marginBottom: 4 }} justify="center" direction="column">
            <PDFText style={styles.title}>
              {`***** ${t('translation:claims.detailedOverChargeClaimStatement')} *****`}
            </PDFText>
          </PDFRow>
          <PDFTable style={{ border: '1px solid #000', borderBottom: 'none' }}>
            <PDFTableRow>
              <PDFTableCell width="10%">
                <PDFText style={styles.tableHeader}>{t('translation:default.fields.shipDate.label')}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="16%">
                <PDFText style={styles.tableHeader}>{t('translation:claims.freightBillProNumber')}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="17%">
                <PDFText style={styles.tableHeader}>{t('translation:default.fields.packageNumber')}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="16%">
                <PDFText style={styles.tableHeader}>{t('translation:default.fields.invoiceNumber')}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="11%">
                <PDFText style={styles.tableHeader}> {t('translation:claims.chargeableWeight')}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="8%">
                <PDFText style={styles.tableHeader}>{t('translation:claims.billedAmount')}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="9%">
                <PDFText style={styles.tableHeader}>{t('translation:claims.paidAmount')}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="9%">
                <PDFText style={styles.tableHeader}>{t('translation:claims.correctCharges')}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="10%" style={{ borderRight: 'none' }}>
                <PDFText style={styles.tableHeader}>{t('translation:default.fields.overchargeAmount')}</PDFText>
              </PDFTableCell>
            </PDFTableRow>
            {claimItems.map((row) => (
              <PDFTableRow key={row.itemID}>
                <PDFTableCell width="10%">
                  <PDFText style={styles.tableText}>{formateWithMoment(row?.shipDate)}</PDFText>
                </PDFTableCell>
                <PDFTableCell width="16%">
                  <PDFText style={styles.tableText}>{row?.proNo}</PDFText>
                </PDFTableCell>
                <PDFTableCell width="17%">
                  <PDFText style={styles.tableText}>{row?.packageNumber}</PDFText>
                </PDFTableCell>
                <PDFTableCell width="16%">
                  <PDFText style={styles.tableText}>{row?.invoiceNumber}</PDFText>
                </PDFTableCell>
                <PDFTableCell width="11%">
                  <PDFText style={styles.tableText}>{row?.weight}</PDFText>
                </PDFTableCell>
                <PDFTableCell width="8%">
                  <PDFText style={styles.tableText}>{row?.billedAmount}</PDFText>
                </PDFTableCell>
                <PDFTableCell width="9%">
                  <PDFText style={styles.tableText}>{row?.paidAmount}</PDFText>
                </PDFTableCell>
                <PDFTableCell width="9%">
                  <PDFText style={styles.tableText}>{row?.correctCharges}</PDFText>
                </PDFTableCell>
                <PDFTableCell width="10%" style={{ borderRight: 'none' }}>
                  <PDFText style={styles.tableText}>{row?.overchargeAmount}</PDFText>
                </PDFTableCell>
              </PDFTableRow>
            ))}
          </PDFTable>
          <PDFRow style={{ marginVertical: 5 }}>
            <View style={{ flex: 1 }} />
            <View style={{ marginHorizontal: 3 }}>
              <PDFText style={{ ...styles.text, whiteSpace: 'nowrap' }}>
                {`${t('translation:claims.totalPaid')} : `}
              </PDFText>
              <PDFText style={{ ...styles.text, whiteSpace: 'nowrap' }}>
                {`${t('translation:claims.correctAmount')} : `}
              </PDFText>
              <PDFText style={{ ...styles.text, whiteSpace: 'nowrap' }}>
                {`${t('translation:default.fields.overchargeAmount')} : `}
              </PDFText>
            </View>
            <View>
              <PDFText style={styles.text}>{claimDetails?.totalPaidAmount}</PDFText>
              <PDFText style={styles.text}>{claimDetails?.totalCorrectCharges}</PDFText>
              <PDFText style={styles.text}>{claimDetails?.overchargeAmount}</PDFText>
            </View>
            <View style={{ height: '100%', marginLeft: 3 }}>
              <PDFRow direction="column" justify="flex-end" style={{ flex: 1 }}>
                <View>
                  <PDFText style={styles.text}>USD</PDFText>
                </View>
              </PDFRow>
            </View>
          </PDFRow>
          <View style={{ ...styles.darkBorder, marginBottom: 3 }} />
          <View>
            <PDFText style={styles.title2}>{t('translation:claims.reasonForOvercharge')}</PDFText>
            <PDFText style={styles.title2}>{t('translation:claims.claimTariff')}</PDFText>
            <PDFText style={styles.title2}>{`${t('translation:claims.contractAuthority')}`}</PDFText>
            <PDFText style={styles.text}>{claimDetails?.claimTypeDesc}</PDFText>
            <View style={{ marginTop: 15 }}>
              {claimDetails.claimComment?.map((row) =>
                row?.commentType === 'x' ? (
                  <PDFRow key={row.sequenceNo}>
                    <View>
                      <PDFText style={styles.text}>{formateWithMoment(row?.createdOn)}</PDFText>
                    </View>
                    <View style={{ marginLeft: 10, flexWrap: 'wrap', width: '90%' }}>
                      <PDFText style={styles.text}>{row?.commentText}</PDFText>
                    </View>
                  </PDFRow>
                ) : null,
              )}
            </View>
          </View>
          <PDFTable
            style={{
              marginTop: 3,
              border: '1px solid #000',
              borderBottom: 'none',
            }}
          >
            <PDFTableRow>
              <PDFTableCell width="21%">
                <PDFText style={styles.tableHeader}>{t('translation:default.fields.auditedBy')}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="21%">
                <PDFText style={styles.tableHeader}>{t('translation:default.fields.submittedBy')}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="21%">
                <PDFText style={styles.tableHeader}>{t('translation:default.fields.preparedBy')}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="21%">
                <PDFText style={styles.tableHeader}>{t('translation:claims.dateSubmitted')}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="21%" style={{ borderRight: 'none' }}>
                <PDFText style={styles.tableHeader}>{t('translation:default.fields.amendmentDate')}</PDFText>
              </PDFTableCell>
            </PDFTableRow>
            <PDFTableRow>
              <PDFTableCell width="21%">
                <PDFText style={styles.tableText}>{claimDetails?.auditedBy}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="21%">
                <PDFText style={styles.tableText}>{claimDetails?.submittedBy}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="21%">
                <PDFText style={styles.tableText}>{claimDetails?.preparedBy}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="21%">
                <PDFText style={styles.tableText}>{claimDetails?.dateSubmitted}</PDFText>
              </PDFTableCell>
              <PDFTableCell width="21%" style={{ borderRight: 'none' }}>
                <PDFText style={styles.tableText}>{claimDetails?.ammendmentDate}</PDFText>
              </PDFTableCell>
            </PDFTableRow>
          </PDFTable>
          <PDFText
            style={{
              ...styles.title2,
              paddingHorizontal: 3,
              letterSpacing: 0.4,
              marginTop: 12,
            }}
          >
            {t('translation:claims.indemnificationClause')}
          </PDFText>
          <View style={{ ...styles.darkBorder, marginTop: 3 }} />
        </View>
      </PDFPage>
    </Document>
  );
};

const styles = StyleSheet.create({
  header: { paddingHorizontal: 10, paddingVertical: 5 },
  title: { fontSize: 10, fontWeight: '600' },
  title2: { fontSize: 8, fontWeight: '600', lineHeight: 1.1 },
  text: { fontSize: 8, fontWeight: '200', lineHeight: 1.15 },
  headerRow: {
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  section: {
    paddingHorizontal: 5,
    paddingVertical: 10,
  },
  darkBorder: {
    backgroundColor: '#000',
    height: 2,
    width: '100%',
    marginVertical: 5,
  },
  tableHeader: {
    fontSize: 8,
    fontWeight: '600',
    lineHeight: 1.1,
    textAlign: 'center',
    paddingBottom: 3,
    paddingTop: 1,
    paddingHorizontal: 1,
  },
  tableText: {
    fontSize: 8,
    fontWeight: '200',
    lineHeight: 1.1,
    paddingBottom: 3,
    paddingTop: 1,
    paddingHorizontal: 1,
  },
});

export default OverChargeClaimDetailsPrint;
